import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||194}
    height={undefined}
    viewBox="0 0 194 168"
    style={{aspectRatio: 194/168}}
    fill="none"
    {...props}
  >
    <path fill="#24EAA8" fillOpacity={0.6} d="m0 0 97 168L194 0H0Z" />
  </svg>
)
export default SvgComponent
